<template>

  <div class="content content-fixed content-auth-alt" style="margin-top:-30px;">
    <div class="container ht-100p">
      <div class="ht-100p d-flex flex-column align-items-center justify-content-center">

        <div class="tx-13 tx-lg-14 mg-b-40">

          <div class="wd-100p">
            <h3 class="tx-color-01 mg-b-5">Reset Password</h3>
            <p class="tx-color-03 tx-16 mg-b-40">Welcome back! Please signin to continue.</p>

            <template v-if="passwordResetSuccess">
              <p> Your Password was successfully changed </p>
              <div class="form-note-s2 pt-5">
                <router-link to="/login"><strong>Return to login</strong></router-link>
              </div>
            </template>

            <template v-else>
              <div class="form-group">
                <label>New Password</label>
                <input v-model="resetDto.password" type="email" class="form-control"
                       placeholder="Enter your new password">
              </div>
              <div class="form-group">
                <div class="d-flex justify-content-between mg-b-5">
                  <label class="mg-b-0-f">Confirm Password</label>
                </div>
                <input v-model="resetDto.confirmPassword" type="password" class="form-control"
                       placeholder="Confirm your new password">
              </div>
              <button v-on:click="resetPassword" class="btn btn-brand-02 w-100">Reset my Password</button>
              <div class="divider-text">or</div>
<!--              <div class="tx-13 mg-t-20 tx-center">Don't have an account?-->
<!--                <router-link to="/login">Return to Login</router-link>-->
<!--              </div>-->
            </template>
          </div>

        </div>
      </div>
    </div><!-- container -->
  </div><!-- content -->

  <Footer/>



</template>


<script>
import Footer from "../components/Footer.vue";

export default {
  name: "ResetPassword",
  components: {Footer},
  data() {
    return {
      resetDto: {
        password: "",
        confirmPassword: "",
        token: this.token,
      },
      passwordResetSuccess: null,
    };
  },
  props: {
    token: {
      type: String,

    },
  },
  methods: {
    async resetPassword() {
      try {
        let result = await this.$axios.post(
            `${this.authServer}/reset-password`,
            this.resetDto
        );
        if (result.status === 200) {
          this.passwordResetSuccess = true;
        }
      } catch (error) {
        if (error.response) {
          alert(JSON.stringify(error.response.data));
        }
      }
    },
    async confirmPasswordResetToken() {
      try {
        let result = await this.$axios.get(
            `${this.authServer}/reset-password?token=${this.token}`
        );
        if (result.status === 200) {
          console.log("Doing  great");
        }
      } catch (error) {
        if (error.response) {
          this.$router.push({
            path: "error",
            query: {
              code: error.response.data.errorCode,
              message: error.response.data.errorMessage,
            },
          });
        }
      }
    },
  },
  mounted() {
    let user = localStorage.getItem("user-info");
    if (user) {
      this.$router.push({name: "Message"});
    } else {
      this.confirmPasswordResetToken();
    }

  },
};
</script>

<style>
@import '../../assets/css/dashforge.auth.css';
</style>


